// Urls
export const GET_GEO_LOCK_API = '/payments/country/isPurchaseAvailable';
export const GET_IS_POLISH_LOCATION_API = '/subscriber/inPoland';
export const GET_IS_EOG_LOCATION_API = '/subscriber/inEog';

// Queries
export const GEO_LOCK_QUERY_KEY = 'geolocation_payment_modal';
export const PLAYING_GEO_LOCK_QUERY_KEY = 'geolocation_playing_modal';

export const GEO_LOCK_QUERY_KEYS = {
	PURCHASE: GEO_LOCK_QUERY_KEY,
	WATCH: PLAYING_GEO_LOCK_QUERY_KEY
};
